import React, { useState, useRef, useEffect } from 'react';

export default function TagFilterControl({
  availableTags = [],
  tagUsageCount = {},
  selectedTags = [],
  setSelectedTags,
  tagLogic,
  setTagLogic
}) {
  const [tagInput, setTagInput] = useState('');
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef(null);
  const [sortMode, setSortMode] = useState('frequency');

  const addTag = (tag) => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
      setTagInput('');
    }
  };

  const removeTag = (tag) => {
    setSelectedTags(selectedTags.filter(t => t !== tag));
  };

  const clearTags = () => {
    setSelectedTags([]);
    setTagInput('');
  };

    const visibleTags = availableTags
    .filter(tag => tag && tag.toLowerCase().includes(tagInput.toLowerCase()))
    .sort((a, b) => {
        if (sortMode === 'alpha') {
        return a.localeCompare(b);
        }
        return (tagUsageCount[b] || 0) - (tagUsageCount[a] || 0);
    });


  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [visibleTags.length]);

  return (
    <div className="tag-filter-control">
      <div className="tag-filter-toolbar">
        <input
          type="text"
          placeholder="Search tags"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          className="tag-input"
        />
        <div className="tag-filter-controls">
          <div className="tag-filter-group">
            <span className="tag-filter-label">Match</span>
            {['AND', 'OR'].map((logic) => (
              <button
                key={logic}
                type="button"
                onClick={() => setTagLogic(logic)}
                className={`tag-toggle tag-toggle-match ${tagLogic === logic ? 'active' : ''}`}
              >
                {logic}
              </button>
            ))}
          </div>

          <div className="tag-filter-group">
            <span className="tag-filter-label">Sort</span>
            <button
              type="button"
              onClick={() => setSortMode('frequency')}
              className={`tag-toggle tag-toggle-sort ${sortMode === 'frequency' ? 'active' : ''}`}
            >
              Frequency
            </button>
            <button
              type="button"
              onClick={() => setSortMode('alpha')}
              className={`tag-toggle tag-toggle-sort ${sortMode === 'alpha' ? 'active' : ''}`}
            >
              A-Z
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={clearTags}
          disabled={selectedTags.length === 0 && !tagInput.trim()}
          className="tag-toggle tag-clear-toggle"
        >
          ✕ Clear
        </button>
      </div>

      <div className="tag-filter-pills-shell">
        <div ref={containerRef} className="tag-pill-list">
          {visibleTags.map((tag, i) => {
            const isSelected = selectedTags.includes(tag);
            return (
              <span
                key={i}
                className={`tag-pill ${isSelected ? 'selected' : ''}`}
                onClick={() => (isSelected ? removeTag(tag) : addTag(tag))}
              >
                {tag}
                {isSelected && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeTag(tag);
                    }}
                    className="tag-pill-close"
                  >
                    ×
                  </button>
                )}
              </span>
            );
          })}
          {!visibleTags.length && (
            <span className="tag-pill-empty">No tags match this search.</span>
          )}
        </div>

        {isOverflowing && <div className="tag-pill-fade" />}
      </div>
    </div>
  );
}
